import React, {useRef, useState} from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { withStyles, Tooltip, IconButton, Typography } from '@material-ui/core';
import { hasPermission, createHistory } from '../../sc-utilities';
import BinaryImageTypeList from './BinaryImageTypeList';
import { FindInPage } from '@material-ui/icons';


const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    progressBarr: {
        width: '100%',
        height: 5
    }
});


const BinaryImageType = props => {
    const tableRef = useRef();
    const { classes, columns, translations, permissions } = props;
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, binaryImageTypeID: null, redirectPath: '' });

    let visible = columns && columns['BinaryImageType'];
    let tableColumns = [
        {
            title: translations["action"] || "Action", field: 'BinaryImageTypeID',
            hidden: visible ? visible['BinaryImageTypeID'] : false,
            cellStyle: { minWidth: 100, maxWidth: 100 },
            filtering: false,
            render: rowData => <>
                {
                    (hasPermission(permissions, 'binary_image_type_load')) ? <Tooltip title={translations["edit_binary_image_type"] || "Edit binary image type"}>
                        <IconButton value={rowData.BinaryImageTypeID} aria-label={translations["edit_binary_image_type"] || "Edit binary image type"} onClick={() => redirectHandler(`/downloads/binaryImageType/edit?binaryImageTypeID=${rowData.BinaryImageTypeID}`)}>
                            <FindInPage />
                        </IconButton>
                    </Tooltip> : null
                }
            </>
        },
        {
            title: translations["key"] || 'Key', field: 'Key',
            hidden: visible ? visible['Key'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Key ? rowData.Key : '-'}</Typography>;
            }
        },
        {
            title: translations["name"] || 'Name', field: 'Name',
            hidden: visible ? visible['Name'] : false,
            filtering: true,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Name ? rowData.Name : ''}</Typography>;
            }
        }
    ];

    const redirectHandler = (path, binaryImageTypeID = null) => {
        createHistory();
        setRedirectOptions({ redirect: true, binaryImageTypeID: binaryImageTypeID, redirectPath: path })
    };

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }


    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'binary_image_type_list') ?
                <BinaryImageTypeList
                    tableColumns={tableColumns}
                    redirectHandler={redirectHandler}
                    tableRef={tableRef}
                />
                :
                null}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        permissions: state?.core?.login?.permissions || []
    };
};



export default connect(
    mapStateToProps,
    null
)(withStyles(styles)(BinaryImageType));
